import React from "react";
import { AddDetailDrawer } from "./AddDetailDrawer";
import { DataBox } from "./DataBox";
import { PageHeader } from "./PageHeader";

export function BaseWarehouse() {
    return (
        <>
            <PageHeader />
            <DataBox />
            <AddDetailDrawer />
        </>
    );
}

